import { useState, useRef } from "react";
import { useMenuService } from "@/services";
import { LocalizationAvailableLangType, MenuItemType } from "@/schemas/index";

export function useMenu() {
  const api = useMenuService();
  const [menuItems, setMenuItems] = useState<MenuItemType[]>();
  const [footerMenuItems, setFooterMenuItems] = useState<MenuItemType[]>();
  const [userMenuItems, setUserMenuItems] = useState<MenuItemType[]>();

  const currentPromiseFetchInit = useRef<any>();
  const currentPromiseFetchFooterMenuInit = useRef<any>();
  const currentPromiseFetchUserMenuInit = useRef<any>();

  const fetchDefaultMenu = (
    currentLang: LocalizationAvailableLangType,
    jwtToken?: string,
  ) => {
    if (currentPromiseFetchInit.current) {
      return currentPromiseFetchInit.current;
    }

    currentPromiseFetchInit.current = api.fetchDefaultMenu(
      currentLang,
      jwtToken,
    );
    currentPromiseFetchInit.current
      .then((menuItems: MenuItemType[]) => {
        setMenuItems(menuItems);
      })
      .finally(() => {
        currentPromiseFetchInit.current = null;
      });

    return currentPromiseFetchInit.current;
  };

  const fetchAdvancedMenu = (
    currentLang: LocalizationAvailableLangType,
    jwtToken?: string,
  ) => {
    if (currentPromiseFetchInit.current) {
      return currentPromiseFetchInit.current;
    }

    currentPromiseFetchInit.current = api.fetchAdvancedMenu(
      currentLang,
      jwtToken,
    );
    currentPromiseFetchInit.current
      .then((menuItems: MenuItemType[]) => {
        setMenuItems(menuItems);
      })
      .finally(() => {
        currentPromiseFetchInit.current = null;
      });

    return currentPromiseFetchInit.current;
  };

  const fetchUserMenu = (
    currentLang: LocalizationAvailableLangType,
    jwtToken?: string,
  ) => {
    if (currentPromiseFetchUserMenuInit.current) {
      return currentPromiseFetchUserMenuInit.current;
    }

    currentPromiseFetchUserMenuInit.current = api.fetchUserMenu(
      currentLang,
      jwtToken,
    );
    currentPromiseFetchUserMenuInit.current
      .then((userMenuItems: MenuItemType[]) => {
        setUserMenuItems(userMenuItems);
      })
      .finally(() => {
        currentPromiseFetchUserMenuInit.current = null;
      });

    return currentPromiseFetchUserMenuInit.current;
  };

  const fetchFooterMenuItems = (
    currentLang: LocalizationAvailableLangType,
    jwtToken?: string,
  ) => {
    if (currentPromiseFetchFooterMenuInit.current) {
      return currentPromiseFetchFooterMenuInit.current;
    }

    currentPromiseFetchFooterMenuInit.current = api.fetchFooterMenu(
      currentLang,
      jwtToken,
    );
    currentPromiseFetchFooterMenuInit.current
      .then((footerMenuItems: MenuItemType[]) => {
        setFooterMenuItems(footerMenuItems);
      })
      .finally(() => {
        currentPromiseFetchFooterMenuInit.current = null;
      });

    return currentPromiseFetchFooterMenuInit.current;
  };

  return {
    menuItems,
    userMenuItems,
    footerMenuItems,
    fetchDefaultMenu,
    fetchUserMenu,
    fetchAdvancedMenu,
    fetchFooterMenuItems,
  };
}
